import { IdentityApi } from 'api/IdentityApi';
import { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { ClipboardXFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

type PropTypes = {
  accessToken: string | null;
  offerNumber: string;
  getOffer: () => Promise<void>;
};

export const ExternalSellerRecallModal = ({
  accessToken,
  offerNumber,
  getOffer,
}: PropTypes) => {
  const [show, setShow] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { t } = useTranslation('components');

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleDecline = async () => {
    setIsLoading(true);
    if (accessToken) {
      await IdentityApi.recallExternalSellerOffer(accessToken);
      toast.success(t('documents.inf_InquiryDeclined'));
    }

    handleClose();

    setIsLoading(false);
    await getOffer();
  };

  return (
    <>
      <Button
        disabled={isLoading}
        onClick={handleShow}
        className='btn-outline-danger d-flex align-items-center'
      >
        <ClipboardXFill className='icon-ez-red me-1' />{' '}
        {t('documents.hd_RecallOffer')}
      </Button>

      <Modal size='sm' show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{t('documents.hd_RecallOffer')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('documents.inf_RecallOffer', { offerNumber })}</p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            disabled={isLoading}
            onClick={handleClose}
            variant='secondary'
          >
            {t('common.btn_Cancel')}
          </Button>
          <Button disabled={isLoading} onClick={handleDecline} variant='danger'>
            {t('common.btn_Ok')}{' '}
            {isLoading && <Spinner animation='border' size='sm' />}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
